// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"33227801","525":"cfcbe2e8"}[chunkId] + ".chunk.js";
};